import { createActions, createReducer } from 'reduxsauce';
import { MIRRORING_PAGENAME } from '../constant';
import util from '../../../core/utils';

// Define Action
const { Types, Creators } = createActions({
  wsConnect: null,
  connected: null,
  register: ['stubNames'],
  unregister: ['stubNames'],
  pull: ['payload'],
  push: ['stubName', 'payload'],
  wsChange: ['payload'],
  gotoPage: ['pageName'],
  disconnect: null,
  // restore: ['pageName', 'roomId', 'socketData'],
});

export const Creator = Creators;
export const Type = Types;

// Define Initial State
const INITIAL_STATE = {
  isConnected: false,
  pageName: MIRRORING_PAGENAME.LOGIN,
  roomId: null,
  socketData: {
    // key : 'screen-connecting',
    // value: 传输的data
  },
};
// Define Reducer
export default createReducer(INITIAL_STATE, {
  [Types.CONNECTED]: (state = INITIAL_STATE, action) => ({
    ...state,
    isConnected: action.connected,
  }),
  [Types.PULL]: (state = INITIAL_STATE, action) => {
    return {
      ...state,
      roomId: action.payload.roomId || state.roomId,
      socketData: {
        ...state.socketData,
        [action.payload.stubName]: { ...action.payload.data },
      },
    };
  },
  [Types.GOTO_PAGE]: (state = INITIAL_STATE, action) => ({
    ...state,
    pageName: action.pageName,
  }),
  [Types.WS_CHANGE]: (state = INITIAL_STATE, action) => ({
    ...state,
    socketData: {
      ...state.socketData,
      ...action.payload,
    },
  }),
  // [Types.RESTORE]: (state = INITIAL_STATE, action) => ({
  //   ...state,
  //   pageName: action.pageName,
  //   roomId: action.roomId,
  //   socketData: action.socketData,
  // }),
});
